<template>
    <outboxCon :bg="bg">
        <div class="subject-intro">
            <app-title :main="main" :sub="sub"></app-title>
            <div class="subject-box">
                <div class="subject-item" v-for="(item, index) in filterSubList" :key="`sub${index}`">
                    <div class="img-box">
                        <img class="icon-sub" :src="item.imgUrl">
                    </div>
                    <p class="sub-name">{{item.name}}</p>
                </div>
            </div>
        </div>
    </outboxCon>
</template>
<script>
export default {
  props: {
    bg: {
      type: String,
      default: ''
    },
    hasSub: {
      type: Array,
      default: () => [1, 2, 3, 4, 5]
    },
    main: {
      type: String,
      default: '小学·初中全学科覆盖教育'
    },
    sub: {
      type: String,
      default: '方便机构扩展学科课程，拉高教学基础'
    }
  },
  data () {
    return {
      subjectList: [
        {
          id: 1,
          name: '语文',
          imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/sub_language.png'
        },
        {
          id: 2,
          name: '数学',
          imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/sub_math.png'
        },
        {
          id: 3,
          name: '英语',
          imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/sub_english.png'
        },
        {
          id: 4,
          name: '物理',
          imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/sub_physics.png'
        },
        {
          id: 5,
          name: '化学',
          imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/sub_chemistry.png'
        }
      ]
    }
  },
  computed: {
    filterSubList () {
      return this.subjectList.filter(item => this.hasSub.indexOf(item.id) > -1)
    }
  }
}
</script>
<style lang="scss" scoped>
    .subject-intro{
        padding: 50px 180px 64px;
        width: $main-width;
        margin: 0 auto;
        .subject-box{
          margin-top: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          .subject-item{
            margin-right: 64px;
            .img-box{
              .icon-sub{
                width: 144px;
                height: 144px;
              }
            }
            .sub-name{
              font-size:22px;
              font-family:PingFangSC-Semibold;
              font-weight: 600;
              line-height:30px;
              margin-top: -30px;
            }
            &:last-of-type{
              margin-right: 0px;
            }
          }
        }
    }
</style>
